export const LoadCaruselLogic = () => {
    const elSlider = document.querySelectorAll("[data-carusel]");
    let ind = 1;
    elSlider.forEach(function(el:any) {
        //console.log('elSlider el: ',el);
        const dataCarusel = el.getAttribute("data-carusel");
        if(dataCarusel === "mobile") {
            //console.log('elSlider mobile el: ',el);
            const caruselID = "data-carusel-" + ind++;
            el.parentElement.setAttribute("data-carusel-mode", "mobile");
            el.setAttribute("id", caruselID);

            const leftStr = el.style.left.replace("px", "");
            const left = parseInt(leftStr);
            checkArrows(el, left);

            //el.nextSibling.style.display = 'flex';//show right arrow
            el.addEventListener('touchstart', handleTouchStart, false);
            el.addEventListener('touchmove', handleTouchMove, false);
            el.nextSibling.addEventListener('click',  function () {arrowClick (caruselID, 'right')}, false);
            el.previousSibling.addEventListener('click',  function () {arrowClick (caruselID, 'left')}, false);

        }

    });

}

var xDown:any = null;
var yDown:any = null;

function getTouches(evt:any) {
    return evt.touches ||             // browser API
        evt.originalEvent.touches; // jQuery
}

function handleTouchStart(evt:any) {
    const firstTouch = getTouches(evt)[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
};

function handleTouchMove(evt:any) {
    if ( ! xDown || ! yDown ) {
        return;
    }
    const speed = 10;
    const carouselElement: any = evt.target.parentElement.parentElement;
    const leftStr = carouselElement.style.left.replace("px", "");
    const left = parseInt(leftStr);
    checkArrows(carouselElement, left);
    //const carouselLimitWidth = (carouselElement.offsetWidth - window.screen.width);

    const xUp = evt.touches[0].clientX;
    const yUp = evt.touches[0].clientY;

    const xDiff = xDown - xUp;
    const yDiff = yDown - yUp;

    if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
        if ( xDiff > 0 ) {
            /* left swipe */
            if(Math.abs(left) >= (carouselElement.offsetWidth - window.screen.width) ) {
                return;
            }
            const leftSwipeLeftPx = (left - 10*(speed/5)) > 0 ? 0 : (left - 10*(speed/5));
            carouselElement.style.left = leftSwipeLeftPx + 'px';

        } else {
            /* right swipe */
            if(left >= 0) {
                return;
            }
            const rightSwipeLeftPx = (left + 10*(speed/5)) > 0 ? 0 : (left + 10*(speed/5));
            carouselElement.style.left = rightSwipeLeftPx + 'px';
        }
    } else {
        if ( yDiff > 0 ) {
            /* down swipe */
        } else {
            /* up swipe */
        }
    }
    /* reset values */
    //xDown = null;
    //yDown = null;
    xDown = evt.touches[0].clientX;
    yDown = evt.touches[0].clientY;
};
function checkArrows(carouselElement: any, left:number){
    if(isNaN(left) ){
        //console.log(`1.left: ${left}, caruselLimit:${carouselElement.offsetWidth - window.screen.width}`);
        return;
    }
    const arrowLeft_Arr:any = carouselElement.parentElement.getElementsByClassName("arr-left");
    const arrowRight_Arr:any = carouselElement.parentElement.getElementsByClassName("arr-right");
    const arrowLeft:any = arrowLeft_Arr.length > 0 ? arrowLeft_Arr[0] : null;
    const arrowRight:any =arrowRight_Arr.length > 0 ? arrowRight_Arr[0] : null;

    //console.log(`2.left: ${left}, caruselLimit:${carouselElement.offsetWidth - window.screen.width}`);

    if(arrowLeft && arrowRight)
    {
        if(left >= 0) {
            arrowLeft.style.display = 'none';
        }
        else {            //left row is hide
            arrowLeft.style.display = 'flex';
        }

        if(Math.abs(left) >= (carouselElement.offsetWidth - window.screen.width - 20) )
            arrowRight.style.display = 'none';
        else
            arrowRight.style.display = 'flex';
    }
}

function arrowClick(caruselID:string, dir:string){
    const carouselElement: any = document.getElementById(caruselID);
    const caruselLimit = carouselElement.offsetWidth - window.screen.width;

    const leftStr = carouselElement.style.left.replace("px", "");
    const left = parseInt(leftStr);
    let moveStep =0;
    //console.log(`left: ${left}, caruselLimit:${caruselLimit}`);

    /*        if(left > 0){
                debugger;
                return;
            }*/


/*    if(Math.abs(left) >= caruselLimit )
        return;*/
    if(dir === 'left'){

        moveStep= left + 200 < 0 ? 200 : -left;
        let leftPx = (left + moveStep) > 0 ? 0 : (left + moveStep);
        carouselElement.style.left = leftPx + 'px';
        checkArrows(carouselElement, leftPx);
    }
    if(dir === 'right'){
        moveStep= caruselLimit + left > 200 ? 200 : caruselLimit + left;
        let leftPx =(left - moveStep) > 0 ? 0 : (left - moveStep);
        carouselElement.style.left = leftPx + 'px';
        checkArrows(carouselElement, leftPx);
    }

}
